import InterfaceGroupModel from 'app/stores/interfaceGroup/InterfaceGroupModel';
import CapacityInterfaceGroupInterfaceCollection from 'app/stores/capacityPlan/CapacityInterfaceGroupInterfaceCollection';

export default class CapacityPlanInterfaceGroupModel extends InterfaceGroupModel {
  interfaceCollection = new CapacityInterfaceGroupInterfaceCollection([]);
}
